export const PERFORMANCE_GROUP = ['C0002']
export const REQUIRED_GROUPS = ['C0002', 'C0004']
export const CONSENT_EVENTS = ['OptanonConsentChanged', 'OneTrustGroupsUpdated']

export const hasPerformanceConsent = () => {
  if (typeof window === 'undefined') return false
  const raw =
    (window.OptanonActiveGroups || window.OnetrustActiveGroups || '') + ''

  const active = new Set(
    raw
      .split(',')
      .map((g) => g.trim())
      .filter(Boolean)
  )
  return PERFORMANCE_GROUP.every((g) => active.has(g))
}

export const hasRequiredConsent = () => {
  if (typeof window === 'undefined') return false
  const raw =
    (window.OptanonActiveGroups || window.OnetrustActiveGroups || '') + ''
  const active = new Set(
    raw
      .split(',')
      .map((g) => g.trim())
      .filter(Boolean)
  )
  return REQUIRED_GROUPS.every((g) => active.has(g))
}
